/** @file withPathPrefix: runs a check and re-throws its Pose3DError with the path moved under a prefix. */
import { throwError } from '@zilo/pose3d-std/errors/throwError';
import { toPose3DError } from '@zilo/pose3d-std/errors/toPose3DError';

/** `f()`, or its error with `path` = `prefix + path` (a document-root path `/` becomes `prefix`). */
export function withPathPrefix<T>(prefix: string, f: () => T): T {
  try {
    return f();
  } catch (e) {
    const err = toPose3DError(e);
    if (err === null) throw e;
    const path = err.path === undefined || err.path === '/' ? prefix : prefix + err.path;
    return throwError(err.code, { ...err.params }, err.hint === undefined ? { path } : { path, hint: err.hint });
  }
}
